import React from "react";
import { Card, CardContent, Box, Typography, Grid } from "@mui/material";
import "./PhoneAccountDetails.scss";

export default function PhoneAccountDetails({
  details,
  transactiondetails,
  invoiceTranslate,
}) {
  return (
    <Card className="buyer-section" elevation={1}>
      <CardContent className="buyer-section__content">
        <Typography variant="subtitle1" className="buyer-section__title">
          {invoiceTranslate.buyerInfo}
        </Typography>

        <Grid container spacing={2} className="buyer-section__grid">
          <Grid item xs={12} sm={6} md={3}>
            <Box className="buyer-inline">
              <Typography className="buyer-inline__label">
                {invoiceTranslate.buyer}:
              </Typography>
              <Typography className="buyer-inline__value">
                {transactiondetails?.[0]?.ClientName || ""}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Box className="buyer-inline">
              <Typography className="buyer-inline__label">
                {invoiceTranslate.nui}:
              </Typography>
              <Typography className="buyer-inline__value">
                {transactiondetails?.[0]?.IdentificationNumber || ""}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Box className="buyer-inline">
              <Typography className="buyer-inline__label">
                {invoiceTranslate.vatNR}:
              </Typography>
              <Typography className="buyer-inline__value">
                {transactiondetails?.[0]?.VATNumber || ""}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Box className="buyer-inline">
              <Typography className="buyer-inline__label">
                {invoiceTranslate.city}:
              </Typography>
              <Typography className="buyer-inline__value">
                {transactiondetails?.[0]?.Adress || ""}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Box className="buyer-inline">
              <Typography className="buyer-inline__label">
                {invoiceTranslate.addres}:
              </Typography>
              <Typography className="buyer-inline__value">
                {transactiondetails?.[0]?.Adress || ""}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Box className="buyer-inline">
              <Typography className="buyer-inline__label">
                {invoiceTranslate.phone}:
              </Typography>
              <Typography className="buyer-inline__value">
                {transactiondetails?.[0]?.PhoneNumbers || ""}
              </Typography>
            </Box>
          </Grid>
          {/* <Grid item xs={6} sm={3}>
            <Typography className="buyer-section__label">City:</Typography>
            <Typography className="buyer-section__value">{details.city}</Typography>
          </Grid> */}

          {/* <Grid item xs={12}>
            <Typography className="buyer-section__label">Address:</Typography>
            <Typography className="buyer-section__value">{details.address}</Typography>
          </Grid> */}

          {/* <Grid item xs={12}>
            <Typography className="buyer-section__label">Phone:</Typography>
            <Typography className="buyer-section__value">{details.phone}</Typography>
          </Grid> */}
        </Grid>
      </CardContent>
    </Card>
  );
}
